// Theme: sakura-midnight
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'sakura-midnight',
  name: 'SAKURA MIDNIGHT',
  tagline: 'SAKURA MIDNIGHT',
  description: 'Sakura midnight com estrutura epica de Sakura em paleta violacea.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1B1020', '#2A1A30', '#C98CD9', '#F6E9FB'],
  familyId: 'sakura-night-v2',
  variantName: 'MIDNIGHT',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-sakura-midnight'
  },
  colorVars: {
    '--accent': '#C98CD9',
    '--accent-foreground': '#1B1020',
    '--background': '#1B1020',
    '--border': '#7A4A6A',
    '--card': '#2A1A30',
    '--card-border-active': 'rgba(201, 140, 217, 0.55)',
    '--card-completed': '#231629',
    '--card-foreground': '#F6E9FB',
    '--card-glow': 'rgba(201, 140, 217, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#F6E9FB',
    '--hold-fill': '#C98CD9',
    '--input': '#7A4A6A',
    '--modal-bg': '#1B1020',
    '--modal-border': '#7A4A6A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#7A4A6A',
    '--muted-foreground': '#F6E9FB',
    '--nav-active': '#C98CD9',
    '--nav-bg': '#2A1A30',
    '--popover': '#2A1A30',
    '--popover-foreground': '#F6E9FB',
    '--primary': '#C98CD9',
    '--primary-foreground': '#1B1020',
    '--ring': '#C98CD9',
    '--secondary': '#7A4A6A',
    '--secondary-foreground': '#F6E9FB',
    '--streak': '#C98CD9',
    '--success': '#22c55e',
    '--success-foreground': '#1B1020',
    '--xp': '#C98CD9',
    '--xp-bg': '#2A1A30'
  },
  resolvedVars: {
    '--accent': '#C98CD9',
    '--accent-foreground': '#1B1020',
    '--accent-foreground-hsl': '281 33% 9%',
    '--accent-foreground-oklch': 'from #1B1020 l c h',
    '--accent-hsl': '288 50% 70%',
    '--accent-oklch': 'from #C98CD9 l c h',
    '--background': '#1B1020',
    '--background-hsl': '281 33% 9%',
    '--background-oklch': 'from #1B1020 l c h',
    '--border': '#7A4A6A',
    '--border-hsl': '320 24% 38%',
    '--border-oklch': 'from #7A4A6A l c h',
    '--border-w': '1px',
    '--card': '#2A1A30',
    '--card-border-active': 'rgba(201, 140, 217, 0.55)',
    '--card-completed': '#231629',
    '--card-completed-hsl': '281 30% 12%',
    '--card-completed-oklch': 'from #231629 l c h',
    '--card-foreground': '#F6E9FB',
    '--card-foreground-hsl': '283 69% 95%',
    '--card-foreground-oklch': 'from #F6E9FB l c h',
    '--card-glow': 'rgba(201, 140, 217, 0.10)',
    '--card-hsl': '284 30% 15%',
    '--card-oklch': 'from #2A1A30 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F6E9FB',
    '--foreground-hsl': '283 69% 95%',
    '--foreground-oklch': 'from #F6E9FB l c h',
    '--hold-fill': '#C98CD9',
    '--hold-fill-hsl': '288 50% 70%',
    '--hold-fill-oklch': 'from #C98CD9 l c h',
    '--input': '#7A4A6A',
    '--input-hsl': '320 24% 38%',
    '--input-oklch': 'from #7A4A6A l c h',
    '--modal-bg': '#1B1020',
    '--modal-bg-hsl': '281 33% 9%',
    '--modal-bg-oklch': 'from #1B1020 l c h',
    '--modal-border': '#7A4A6A',
    '--modal-border-hsl': '320 24% 38%',
    '--modal-border-oklch': 'from #7A4A6A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#7A4A6A',
    '--muted-foreground': '#F6E9FB',
    '--muted-foreground-hsl': '283 69% 95%',
    '--muted-foreground-oklch': 'from #F6E9FB l c h',
    '--muted-hsl': '320 24% 38%',
    '--muted-oklch': 'from #7A4A6A l c h',
    '--nav-active': '#C98CD9',
    '--nav-active-hsl': '288 50% 70%',
    '--nav-active-oklch': 'from #C98CD9 l c h',
    '--nav-bg': '#2A1A30',
    '--nav-bg-hsl': '284 30% 15%',
    '--nav-bg-oklch': 'from #2A1A30 l c h',
    '--popover': '#2A1A30',
    '--popover-foreground': '#F6E9FB',
    '--popover-foreground-hsl': '283 69% 95%',
    '--popover-foreground-oklch': 'from #F6E9FB l c h',
    '--popover-hsl': '284 30% 15%',
    '--popover-oklch': 'from #2A1A30 l c h',
    '--primary': '#C98CD9',
    '--primary-foreground': '#1B1020',
    '--primary-foreground-hsl': '281 33% 9%',
    '--primary-foreground-oklch': 'from #1B1020 l c h',
    '--primary-hsl': '288 50% 70%',
    '--primary-oklch': 'from #C98CD9 l c h',
    '--radius': '12px',
    '--ring': '#C98CD9',
    '--ring-hsl': '288 50% 70%',
    '--ring-oklch': 'from #C98CD9 l c h',
    '--secondary': '#7A4A6A',
    '--secondary-foreground': '#F6E9FB',
    '--secondary-foreground-hsl': '283 69% 95%',
    '--secondary-foreground-oklch': 'from #F6E9FB l c h',
    '--secondary-hsl': '320 24% 38%',
    '--secondary-oklch': 'from #7A4A6A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#C98CD9',
    '--streak-hsl': '288 50% 70%',
    '--streak-oklch': 'from #C98CD9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1B1020',
    '--success-foreground-hsl': '281 33% 9%',
    '--success-foreground-oklch': 'from #1B1020 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(288 50% 70% / 0.15)',
    '--xp': '#C98CD9',
    '--xp-bg': '#2A1A30',
    '--xp-bg-hsl': '284 30% 15%',
    '--xp-bg-oklch': 'from #2A1A30 l c h',
    '--xp-hsl': '288 50% 70%',
    '--xp-oklch': 'from #C98CD9 l c h'
  }
}
